module.exports = __webpack_public_path__ + "img/bone.9a52b726.svg";